export default __webpack_public_path__ + "images/Brazilian.d25f41.jpg";